














































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {enhancedEcommerce} from '../../shared/helpers/enhanced-ecommerce';
import {imageGallery} from '../../shared/helpers/image-gallery';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'catalog-product-list-item',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  @Prop({required: true}) readonly dataSource: string;
  @Prop({required: true}) readonly product: object;
  @Prop({default: null}) readonly type: string | null;
  @Prop({default: true}) readonly lazyImage: boolean;
  @Prop({required: false}) initialWishlistState: boolean;

  private wishlistToggle: boolean = this.isOnWishlist;
  private loadingWishlist: boolean = false;

  private get listTypeClass(): string {
    switch (this.type) {
      case 'home':
      case 'block':
        return;
      case 'category':
        return 'small-12 medium-8 large-6 cell category__item-holder';
      case 'slider':
        return '';
      case 'wishlist':
        return 'small-24 medium-8 cell';
      default:
        return 'small-12 medium-8 large-6 cell';
    }
  }

  private get productImage(): string {
    return imageGallery.getSingleImage(this.product, '185x185');
  }

  private get impressionImage(): string {
    return imageGallery.getImpressionImage(this.product, '185x185');
  }
  private get hasImpressionImage(): boolean {
    return !!this.impressionImage;
  }

  private get checkPrice(): boolean {
    return (this.product['retail_price'] !== this.product['final_price_incl_tax']) && this.product['retail_price'] > this.product['final_price_incl_tax'];
  }

  private get getBigPrice(): void {
    let price = this.product['final_price_incl_tax'].priceFormat();
    return price.split(',')[0];
  }

  private get getSmallPrice(): void {
    let price = this.product['final_price_incl_tax'].priceFormat();
    return price.split(',')[1];
  }

  private get getOldPrice(): void {
    return this.product['retail_price'].priceFormat();
  }

  private get getStockMessage(): string {
    return this.checkIfOutOfStock ? `Niet op voorraad. ${this.product['delivery_text']}` : `${this.product['delivery_text']}`;
  }

  private get productDiscount(): number {
    return 100 - Math.round((this.product['price_incl_tax'] / this.product['retail_price']) * 100);
  }

  private addProductClick(): void {
    enhancedEcommerce.addProductClick(this.product, this.$vnode.key);
  }

  private get checkIfOutOfStock(): boolean {
    if (this.product['product_type'] === 'bundle') {
      return !this.product['delivery_in_stock'];
    }
    if (this.product['product_type'] === 'simple') {
      return this.product['frontend_stock'] <= 0;
    }
  }

  private async toggleWishlist(): Promise<void> {
    this.loadingWishlist = true;
    try {
      await this.$store.dispatch('CustomerWishlist/toggleWishlistProduct', this.product['product_id']);
      if (this.type !== 'wishlist') {
        await this.$store.dispatch('CustomerWishlist/updateWishlistCount', !this.wishlistToggle);

        this.wishlistToggle = !this.wishlistToggle;
      } else {
        await this.$store.dispatch('CustomerWishlist/updateWishlistCount', false);
        this.$eventBus.$emit('remove-wishlist', this.product['product_id']);
      }
    } catch (e){
      console.log(e);
    } finally{
      this.loadingWishlist = false;
    }
  }

  private changeImage(): void {
    (this.$refs.image as HTMLImageElement).src = this.impressionImage;
  }

  private resetImage(): void {
    (this.$refs.image as HTMLImageElement).src = this.productImage;
  }

  private handleMouseOver(): void {
    if (this.hasImpressionImage) {
      this.changeImage();
    }
  }

  private handleMouseLeave(): void {
    if (this.hasImpressionImage) {
      this.resetImage();
    }
  }
  private mounted(): void {
    this.$forceUpdate();
  }
  private updated(): void {
    this.$eventBus.$emit('item-rendered', true);
  }
  private get wishlistItems() {
    return Object.values(this.$store.getters['CustomerWishlist/wishlistProducts']);
  }
  private get isOnWishlist(): boolean {
    if (this.type === 'wishlist') {
      return true;
    }

    if (!this.wishlistItems) {
      return false;
    }

    return !!this.wishlistItems.filter(p => p['id'] === this.product['id']).length;
  }
}
